import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=28ef5642&scoped=true&"
import script from "./FormTable.vue?vue&type=script&lang=js&"
export * from "./FormTable.vue?vue&type=script&lang=js&"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=28ef5642&lang=scss&scoped=true&"
import style1 from "./FormTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef5642",
  null
  
)

export default component.exports